import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductSalesGroup } from '../../entities/control-tables/product-sales-group';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

export class ProductSalesGroupRequest extends BaseRequest {

    productSalesGroup : ProductSalesGroup

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.productSalesGroup = new ProductSalesGroup()
  }
}